<!--
   본 소프트웨어는 관련 법률에 따라 보호되는 삼성의 지식재산 및 영업비밀 입니다. 본 소프트웨어를 권한 없이 사용하거나 삼성의 사전 서면 동의 없이 제3자에게 공개하는 행위는
   엄격히 금지되어 있으며 위반 시 귀하는 무단 사용 또는 비밀 유지 의무 위반에 대해 법적인 책임을 져야 합니다. This software is the intellectual
   property and confidential information of Samsung Electronics, Co., Ltd. (“Samsung”) protected by
   applicable laws. The unauthorized use or disclosure of the software to any third party without
   the prior written consent of Samsung is strictly prohibited, and you should be legally
  responsible for the unauthorized use or violation of confidentiality obligation.
-->
<!--
  Program: Side menu
  Author: SDL
  Brief: side menu common layout
-->
<template>
  <nav class="bg-light ui--lnb-container">
    <a
      v-show="rootMenu.menuId"
      class="ui--lnb-collapsed-icon"
      href="javascript:"
      @click="isFoldMenu = !isFoldMenu"
      data-trigger-resize=""
      data-toggle-state="ui---lnb-collapsed"
    >
      <em :class="isFoldMenu ? 'icon-arrow-right' : 'icon-arrow-left'"></em>
    </a>
    <div class="ui--lnb-inner">
      <div class="ui--nav-heading">{{ getLabel(rootMenu) }}</div>
      <nav class="ui--sidebar">
        <!-- Level2 -->
        <ul class="ui--sidebar-nav">
          <li v-for="menu in groupMenus" :key="menu.menuId" :class="{ active: selGroupId === menu.menuId }">
            <strong>
              <a href="javascript:" v-if="menu.externalUrlUsed === true" @click="openExternalUrl(menu.externalUrl)">
                <span>{{ getLabel(menu) }} <i class="material-icons ui--menu-icon-2">open_in_new</i></span>
              </a>
              <a href="javascript:" v-else-if="menu.defaultPage" @click="moveMenu(menu.defaultPage.pagePath)">
                <span>{{ getLabel(menu) }} <i class="material-icons ui--menu-icon-2">arrow_forward_ios</i></span>
              </a>
              <a href="javascript:" v-else @click="groupSelect(menu)">
                <span>{{ getLabel(menu) }}</span>
              </a>
              <button class="btn ui--btn-sidebar" @click="groupSelect(menu)">
                <em
                  :class="{
                    'icon-arrow-up': selGroupId === menu.menuId,
                    'icon-arrow-down': selGroupId !== menu.menuId,
                  }"
                ></em>
              </button>
            </strong>
            <!-- Level3 -->
            <ul class="colapse ui--sidebar-nav ui--sidebar-subnav" :class="{ show: selGroupId === menu.menuId }">
              <li
                v-for="subMenu in getSubMenus(menu.menuId)"
                :key="subMenu.menuId"
                :class="{ active: selMenuId === subMenu.menuId }"
                @click="
                  subMenu.externalUrlUsed === true ? openExternalUrl(subMenu.externalUrl) : moveMenu(subMenu.menuUrl)
                "
              >
                <a href="javascript:">
                  {{ getLabel(subMenu) }}
                  <i v-if="subMenu.externalUrlUsed === true" class="material-icons ui--menu-icon-3">open_in_new</i></a
                >
              </li>
            </ul>
          </li>
        </ul>
      </nav>
    </div>
  </nav>
</template>
<script>
import { mapGetters } from 'vuex';
import _ from 'lodash';
import store from '@/vuex/store';
import SDLLocale from '@/mixin/SDLLocale';

export default {
  name: 'SideMenu',
  mixins: [SDLLocale],
  data() {
    return {
      rootMenu: {},
      groupMenus: [],
      selGroupId: '',
      selMenuId: '',
      isFoldMenu: false,
    };
  },
  computed: {
    ...mapGetters({
      menus: 'getMenus', // Receive menus with getter
    }),
  },
  watch: {
    isFoldMenu(value) {
      this.$emit('fold-event', value);
    },
    $route() {
      this.selMenuId = this.$route.meta.menuId;
      this.init();
    },
  },
  methods: {
    init() {
      const curMenu = this.getCurrentMenu();
      if (curMenu) {
        let list = [curMenu];
        for (let i = curMenu.menuLevel - 1; i > 0; i -= 1) {
          const parentMenu = this.getParentMenu(list[0].parentId);
          if (parentMenu) {
            list = [parentMenu, ...list];
          }
        }
        this.rootMenu = this.menus.find(menu => menu.menuLevel === 1 && menu.menuId === list[0].menuId);
        this.groupMenus = this.menus.filter(menu => menu.menuLevel === 2 && menu.parentId === this.rootMenu.menuId);
        // 순서 정렬
        this.groupMenus = _.sortBy(this.groupMenus, ['menuSequence']);
        this.selGroupId = list[1] ? list[1].menuId || '' : '';
        this.selMenuId = _.last(list).menuId;
      } else {
        this.rootMenu = {};
      }
    },
    moveMenu(pagePath) {
      // 메뉴에서 강제로 이동시에는 저장된 파라미터 초기화
      // Initialize saved parameters when forced to move from the menu
      // Initialize stored parameters when forced to move from menu
      store.commit('PARAMS', {});
      this.$router.push({ path: pagePath });
      // If the moving component is the same, refresh is required
      const fromComponentName = this.$route.meta.componentName;
      const toMenu = _.find(this.menus, ['menuUrl', pagePath]);
      if (fromComponentName === toMenu.componentName) {
        this.$emit('router-reload');
      }
    },
    getCurrentMenu() {
      const { menuId } = this.$route.meta;
      return this.menus.find(item => item.menuId === menuId);
    },
    getParentMenu(parentId) {
      return this.menus.find(item => item.menuId === parentId);
    },
    getSubMenus(parentId) {
      return _.sortBy(this.menus.filter(menu => menu.parentId === parentId), ['menuSequence']);
    },
    groupSelect(menu) {
      if (_.find(this.menus, ['parentId', menu.menuId])) {
        this.selGroupId = this.selGroupId === menu.menuId ? '' : menu.menuId;
      } else {
        this.$router.push({ path: menu.menuUrl });
      }
    },
    openExternalUrl(url) {
      window.open(url.startsWith('http') ? url : `http://${url}`, '_blank');
    },
  },
  created() {
    this.init();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/view/admin/main/MainSideMenu.vue